import { useAuth } from '@context-providers/auth-context-provider'
import { AuthErrorPage } from '@pages/error/auth-error.page'
import { DASHBOARD_TABS } from '@routes/_auth-routes/$programId/$deliverableId/$tab'
import { createFileRoute, Navigate } from '@tanstack/react-router'

import { useUserPrograms } from '@hooks/use-user-programs'
import { InfoCard } from '@postxl/ui-components'

export const Route = createFileRoute('/_auth-routes/$programId/')({
  component: ProgramRedirect,
})

// redirect to first tab of program of the first tree item
function ProgramRedirect() {
  const { programId } = Route.useParams()
  const { viewerData } = useAuth()
  const { isLoaded, programs } = useUserPrograms()

  if (!viewerData?.programs || !programId || !isLoaded) {
    return <InfoCard variant="loading" title="Loading Programs" message="Please wait while we load your programs..." />
  }

  if (isLoaded && programs.length === 0) {
    // use component instead of 'navigate' to /auth-error, because isLoaded is set to `true` - two render cycles before
    // `userPrograms` contains data
    return <AuthErrorPage errorType={'errorNoProgram'} />
  }

  const rootDeliverableId = viewerData.programs[programId]
  return (
    <Navigate
      to="/$programId/$deliverableId/$tab"
      params={{ programId, deliverableId: rootDeliverableId, tab: DASHBOARD_TABS.WORKSTREAM }}
    />
  )
}
